import React, { useEffect, useState } from "react";
import Modal from "../../Modal";
import LoaderForImage from "../../LoaderForImage";
import upploadImage from "../../../assets/images/upload-video.png";
import { imageUpload } from "../../../features/slices/liveStream";
import { toastService } from "../../../utils/toastify";
import { useDispatch } from "react-redux";
const UpdateChallenegeVideo = ({ setShowModal, videoData }) => {
  const [imageLoader, setimageLoader] = useState(false);
  const [error, setError] = useState(false);
  const [video, setVideo] = useState("");
  useEffect(() => {
    setVideo(videoData);
  }, []);

  const handleClose = () => {
    setShowModal((prev) => ({ ...prev, update: false }));
  };
  const dispatch = useDispatch();
  const handleVideo = (e) => {
    const file = e.target.files[0];
    setError("");
    if (file) {
      const formData = new FormData();
      formData.append("fileName", file);

      dispatch(imageUpload(formData)).then((res) => {
        if (res?.payload?.code === 200) {
          toastService.success("Video uploaded successfully");
          setVideo(res?.payload?.url);
        } else {
          toastService.error("Failed to upload video");
        }
      });
    }
  };
  return (
    <Modal>
      <div className="modal-body">
        <div className="Category">
          <a className="CloseModal" onClick={handleClose}>
            ×
          </a>
          <h3>Edit Video</h3>
          <div className="CommonForm">
            <div>
              <div
                className="UploadBox Image"
                style={{ position: "relative", zIndex: 0 }}
              >
                <span>
                  {!video && <img src={upploadImage} alt="Upload" />}{" "}
                  {/* Default upload image */}
                  {video && (
                    <>
                      <video
                        src={video} // Create a URL for the uploaded Video file
                        controls
                        controlsList="nodownload"
                        style={{
                          position: "absolute",
                          top: "0",
                          left: "0",
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          mixBlendMode: "darken",
                          zIndex: 1, // Make sure the Video is above the input
                        }}
                      />
                      {/* Edit icon to update the Video */}
                      <i
                        className="fas fa-edit"
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          color: "#fff",
                          background: "rgba(0, 0, 0, 0.6)",
                          borderRadius: "50%",
                          padding: "5px",
                          zIndex: 2, // Place icon above the Video
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          document.querySelector(`#file-input`).click()
                        } // Trigger file input on icon click
                      />
                    </>
                  )}
                </span>

                {/* File input field */}
                <input
                  id={`file-input`} // Unique ID for each input
                  type="file"
                  name="video"
                  accept=".mp4" // Accept only video files
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    opacity: 0, // Hide input when a video is present
                    zIndex: video ? 0 : 2,
                    cursor: "pointer",
                  }}
                  onChange={handleVideo} // Pass the actual file to handleCourseMedia
                />

                {/* Text to prompt upload if no Video is uploaded */}
                {!video && (
                  <p>
                    <label>Click to upload video</label> or <br /> drag &amp;
                    drop
                  </p>
                )}
              </div>
              {error && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {error}
                </p>
              )}
            </div>
          </div>
          <button className="Button" data-dismiss="modal">
            Update
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default UpdateChallenegeVideo;
